import { AdminScopeTestBidder, AdminScopeTestBidderUpdate } from '@pubstack/common/src/pbs/pbs-test-bidder'
import { MutationToasts, useMutation, useQuery } from '../api-client'

export const PBS_SCOPE_CONFIG_QUERY_KEYS = ['admin', 'pbs-scope-config']

export const ADMIN_SCOPE_TEST_BIDDER_QUERY_KEYS = (scopeId: string) => [...PBS_SCOPE_CONFIG_QUERY_KEYS, scopeId, 'test-bidder']

export const useAdminScopeTestBidder = (scopeId?: string) => {
  return useQuery<AdminScopeTestBidder>({
    url: `/admin/scopes/${scopeId}/pbs-scope-config/test-bidder`,
    keys: ADMIN_SCOPE_TEST_BIDDER_QUERY_KEYS(scopeId ?? ''),
    enabled: !!scopeId,
  })
}

export const useUpdateAdminScopeTestBidder = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<AdminScopeTestBidderUpdate>({
    method: 'put',
    url: `/admin/scopes/${scopeId}/pbs-scope-config/test-bidder`,
    collectionKeys: ADMIN_SCOPE_TEST_BIDDER_QUERY_KEYS(scopeId),
    ...toasts,
  })
}
